import { render, staticRenderFns } from "./group-card.vue?vue&type=template&id=4112fbc6&lang=pug&"
import script from "./group-card.vue?vue&type=script&lang=js&"
export * from "./group-card.vue?vue&type=script&lang=js&"
import style0 from "./group-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports